// extracted by mini-css-extract-plugin
export default {"login-form__container":"login_login-form__container__5Mai-","login-form__overlay-container":"login_login-form__overlay-container__rkTSy","login-button":"login_login-button__rhVcT"};